import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { FormattedMessage, injectIntl } from 'react-intl'
import { FormData, Files } from 'components/misc'
import { Title, Section } from 'components/layout'
import styles from './assessor-report.styl'
import {
  apiActivities,
  apiAjEvents,
  apiResidentialProjects
} from 'helpers/decorators/api'

@injectIntl
@apiActivities()
@apiResidentialProjects()
@apiAjEvents()
class AssessorReport extends Component {
  static propTypes = {
    id: PropTypes.number.isRequired,
    intl: PropTypes.object,
    actionId: PropTypes.number,
    isActivity: PropTypes.bool,
    isParticipantEvent: PropTypes.bool,
    isResidentialProject: PropTypes.bool,
    getActivityAssessment: PropTypes.func,
    getAjParticipantEventAssessment: PropTypes.func,
    getResidentialProjectAssessment: PropTypes.func,
    removeActivityAssessment: PropTypes.func,
    removeAjParticipantEventAssessment: PropTypes.func,
    removeResidentialProjectAssessment: PropTypes.func,
    assessed: PropTypes.bool,
    supervisor: PropTypes.bool,
    isAssessorReportAdditionalInfoEnabled: PropTypes.bool
  }

  componentDidMount() {
    const {
      id,
      actionId,
      isActivity,
      isParticipantEvent,
      isResidentialProject,
      getActivityAssessment,
      getAjParticipantEventAssessment,
      getResidentialProjectAssessment
    } = this.props

    isActivity && actionId && getActivityAssessment(id, actionId)
    id &&
      isParticipantEvent &&
      actionId &&
      getAjParticipantEventAssessment(id, actionId)
    isResidentialProject &&
      actionId &&
      getResidentialProjectAssessment(id, actionId)
  }

  componentWillUnmount() {
    this.props.removeActivityAssessment()
    this.props.removeAjParticipantEventAssessment()
    this.props.removeResidentialProjectAssessment()
  }

  render() {
    const {
      assessed,
      supervisor,
      isActivity,
      isParticipantEvent,
      isResidentialProject,
      intl,
      isAssessorReportAdditionalInfoEnabled
    } = this.props

    let type = null

    if (isActivity) {
      type = 'activities'
    }

    if (isParticipantEvent) {
      type = 'ajEvents'
    }

    if (isResidentialProject) {
      type = 'residentialProjects'
    }

    const assessment = get(this.props, `${type}.assessment`)

    const assessmentData = get(this.props, `${type}.assessment.data`)

    let role = intl.formatMessage({
      id: 'global.assessor',
      defaultMessage: 'Assessor'
    })

    if (supervisor) {
      role = intl.formatMessage({
        id: 'global.supervisor',
        defaultMessage: 'supervisor'
      })
    }


    return (
      <div>
        <div>
          <Section loading={assessment.loading}>
            {get(assessmentData, 'assessorReportDetail.firstName') &&
              <h2>
                {get(assessmentData, 'assessorReportDetail.title')
                  ? `${assessmentData.assessorReportDetail.title}.`
                  : ''}
                {' '}
                {get(assessmentData, 'assessorReportDetail.firstName')}{' '}
                {get(assessmentData, 'assessorReportDetail.lastName')}
              </h2>}
            {get(assessmentData, 'assessorReportDetail.assessorReport') &&
              <div className="row">
                <div className="col-xs-6">
                  <FormData label="Email" intlKey="label.email">
                    {get(assessmentData, 'assessorReportDetail.email')}
                  </FormData>
                </div>
                <div className="col-xs-6">
                  <FormData label="Phone" intlKey="label.phone">
                    {get(assessmentData, 'assessorReportDetail.phone')}
                  </FormData>
                </div>
                <div className="col-xs-12">
                  <FormData label="Personal summary" intlKey="label.personal_reflection">
                    <p className={styles.report}>
                      {get(assessmentData, 'personalReflection')}
                    </p>
                  </FormData>
                </div>
                <div className="col-xs-12">
                  <FormData label="Report" intlKey="label.report">
                    <p className={styles.report}>
                    {get(assessmentData, 'assessorReportDetail.assessorReport')}
                    </p>
                  </FormData>
                  {isAssessorReportAdditionalInfoEnabled && <FormData>
                    <p className={styles.report}>
                      {get(assessmentData, 'assessorReportDetail.assessorReportAdditionalInfo')}
                    </p>
                  </FormData>}
                </div>
                <div className="col-xs-6">
                  <FormData label="Qualification" intlKey="label.qualifications">
                    {get(
                      assessmentData,
                      'assessorReportDetail.myQualification'
                    ) || '---'}
                  </FormData>
                </div>
                <div className="col-xs-6">
                  <FormData label="Experience" intlKey="label.experience">
                    {get(assessmentData, 'assessorReportDetail.myExperience') ||
                      '---'}
                  </FormData>
                </div>
              </div>}
          </Section>
        </div>
        {!assessment.loading &&
          !get(assessmentData, 'assessorReportDetail.assessorReport') &&
          assessed &&
          <div>
            <Title
              h2
              intlKey="moduleTitle.assessor_report"
              intlValues={{ role }}
            >
              Assessor report
            </Title>
            {get(assessmentData, 'note') &&
              <FormData
                label="Note from participant"
                intlKey="label.note_from_participant"
              >
                {assessmentData.note}
              </FormData>}
            {get(assessmentData, 'assessorReportDetail.fileUrls')
              ? <Files
                  urls={get(assessmentData, 'assessorReportDetail.fileUrls')}
                  decoWithCode
                />
              : <FormattedMessage
                  id="label.no_data"
                  defaultMessage="No data"
                />}
          </div>}
      </div>
    )
  }
}

export default AssessorReport
